class Header {
  constructor() {
    this.$el = document.querySelector('#header');
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.onResize = this.onResize.bind(this);
    this.observer = new ResizeObserver(this.onResize);
    this.observer.observe(this.$el);
    this.aboutButton = Array.from(this.$el.querySelectorAll('a')).find(a => a.textContent.toLowerCase().includes('about') || a.textContent.toLowerCase().includes('sobre'));

    if (this.aboutButton) {
      this.aboutButton.href += '#about';
    }
  }
  onScroll() {
    this.$el.classList.toggle('sticky', window.scrollY > window.innerHeight * 0.5);
  }
  onResize() {
    const items = this.$el.querySelector('.header-items');
    const itemsW = items.getBoundingClientRect().width;
    const offset = this.$el.querySelector('.header-items a').clientWidth * 0.5;
    document.documentElement.style.setProperty('--nav-items', `${itemsW + offset}px`);
  }
}